import { useController } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { Input } from '@mui/material';

import { useQuery } from '@hooks';
import { FormRow, ReferenceInput, SelectInput } from '@components';
import { dealerHttp } from '@network';
import { Dealer } from '@types';
import cls from '@pages/manager/ManagerCreate/ManagerCreate.module.css';
import _cls from './AssociateCompany.module.css';

export const AssociateCompany = ({ autoUpdate }: {autoUpdate: boolean}) => {
  const query = useQuery();
  const queryDealerId = query.get('dealerId');
  const [dealer, setDealer] = useState<Dealer>();

  const {
    field: { value: dealerId, onChange: setDealerId },
  } = useController({ name: 'buyerId' });
  const {
    field: { value: associateId },
  } = useController({ name: 'associateId' });
  const {
    field: { onChange: setName },
  } = useController({ name: 'name' });
  const {
    field: { onChange: setPhone },
  } = useController({ name: 'phone' });
  const {
    field: { onChange: setEmail },
  } = useController({ name: 'email' });

  useEffect(() => {
    autoUpdate && associateId && (async () => {
      const dealer = await dealerHttp.getById(associateId);
      if (dealer) {
        setName(dealer.name);
        setPhone(dealer.phone || '');
        setEmail(dealer.email || '');
      }
    })();
  }, [autoUpdate, associateId]);

  useEffect(() => {
    if (queryDealerId) {
      setTimeout(() => void setDealerId(+queryDealerId), 0);
      setTimeout(() => void setDealerId(+queryDealerId), 1000);
      setTimeout(() => void setDealerId(+queryDealerId), 2000);
      setTimeout(() => void setDealerId(+queryDealerId), 5000);
    }
  }, [queryDealerId]);

  useEffect(() => {
    if (queryDealerId || dealerId) {
      dealerHttp.getById(queryDealerId || dealerId).then(d => setDealer(d));
    }
  }, [queryDealerId, dealerId]);

  const mainColGrid = {
    xxl: { title: 7, children: 17 },
    sm: { title: 10, children: 14 },
    xs: { title: 24, children: 24 },
  };

  return (
    <>
      <FormRow
        title="Company name:"
        width={mainColGrid}
        rowClassName={clsx(cls.formRow, cls.mainFormRow)}
        colTitleClassName={cls.formLabelCol}
        colChildrenClassName={clsx(cls.formValueCol, cls.formMainValue)}
      >
        <Input disabled className={_cls.nocompany} value={dealer?.name ?? 'No Company'} />
      </FormRow>
      <FormRow
        title={`Associate name${queryDealerId ? '' : '*'}:`}
        width={mainColGrid}
        rowClassName={clsx(cls.formRow, cls.mainFormRow)}
        colTitleClassName={cls.formLabelCol}
        colChildrenClassName={clsx(cls.formValueCol, cls.formMainValue)}
      >
        <ReferenceInput
          name={'associateId'}
          source={'associateId'}
          reference={'dealer-associate'}
          isRequired={!queryDealerId}
          perPage={1000}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <SelectInput optionText="name" required label={false} />
        </ReferenceInput>
      </FormRow>
    </>
  );
};
